export default __webpack_public_path__ + "static/media/ebay.9c86e5ce.svg";